
define('text!templates/appMain/privilegedMain/qm/policies/editors/dateEditor.html',[],function () { return '<input class="form-control" type="date" data-bind="value: browserDateString">\n';});

